import { format } from 'date-fns/format';

export function parseDate(date: string): Date {
  if (!date.includes(' ')) {
    date = `${date} 00:00:00`;
  }

  date = date.replace(' ', 'T');

  return new Date(date);
}

export function formatDate(date: string, formatString: string): string {
  const parsedDate = parseDate(date);
  return format(parsedDate, formatString);
}
